var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgGroups = function SvgGroups(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#111827",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "M21.429 18v-.94c0-1.183-.96-2.142-2.143-2.142h-.687M2.571 18v-.94c0-1.183.96-2.142 2.143-2.142h.687M16.576 18v-1.372a3 3 0 0 0-3-3h-3.153a3 3 0 0 0-3 3V18m12.113-8.123a1.734 1.734 0 1 1-2.452 2.452 1.734 1.734 0 0 1 2.452-2.452Zm-5.648-3.095a2.67 2.67 0 1 1-3.776 3.776 2.67 2.67 0 0 1 3.776-3.776ZM6.916 9.877a1.734 1.734 0 1 1-2.452 2.452 1.734 1.734 0 0 1 2.452-2.452Z"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgGroups);
export default ForwardRef;